export default "__VITE_ASSET__ChHlPFS9__"